import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_search",
  "use": "icon-i_search-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_search\"><title>icon_画板</title><path d=\"M15.08,26.68a11.9,11.9,0,1,1,8.43-3.48A11.87,11.87,0,0,1,15.08,26.68Zm0-21.53A9.63,9.63,0,1,0,21.89,8,9.57,9.57,0,0,0,15.08,5.15Z\" /><path d=\"M29.7,31.15a1.11,1.11,0,0,1-.84-.37l-7-7.62a1.14,1.14,0,0,1,1.68-1.54l7,7.62a1.14,1.14,0,0,1-.84,1.91Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol